"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zodIssuesToStrings = zodIssuesToStrings;
var z = _interopRequireWildcard(require("zod"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function zodIssuePathToText(zodIssuePath) {
  return zodIssuePath.length > 0 ? ` at path "${zodIssuePath.join('.')}"` : '';
}
function zodIssueToString(zodIssue) {
  if (zodIssue.code === z.ZodIssueCode.invalid_type) {
    return `Expected "${zodIssue.expected}" but received "${zodIssue.received}"${zodIssuePathToText(zodIssue.path)}`;
  }
  if (zodIssue.code === z.ZodIssueCode.unrecognized_keys) {
    return `Unrecognized ${zodIssue.keys.length >= 2 ? 'keys' : 'key'} ${zodIssue.keys.map(key => `"${key}"`).join(', ')}${zodIssuePathToText(zodIssue.path)}`;
  }
  if (zodIssue.code === z.ZodIssueCode.invalid_union) {
    return `Invalid union: ${zodIssue.unionErrors.map(unionError => unionError.issues.map(issue => {
      const zodIssueString = [...zodIssueToString(issue)];
      if (zodIssueString[0]) {
        zodIssueString[0] = zodIssueString[0].toLowerCase();
      }
      return zodIssueString.join('');
    }).join(', ')).join('; ')}`;
  }
  if (zodIssue.code === 'invalid_enum_value') {
    return `Expected ${zodIssue.options.length === 1 ? `"${zodIssue.options[0]}"` : `${zodIssue.options.map(option => `"${option}"`).slice(0, -1).join(', ')} or "${zodIssue.options[zodIssue.options.length - 1]}"`}${zodIssuePathToText(zodIssue.path)}`;
  }
  return `${zodIssue.message}${zodIssuePathToText(zodIssue.path)}`;
}
function zodIssuesToStrings(zodIssues) {
  return zodIssues.map(zodIssue => zodIssueToString(zodIssue));
}
//# sourceMappingURL=zodIssuesToString.js.map